/** Mirrors the backend's AvatarPresets.ALL — every valid value for User.avatarPreset. Kept out
 *  of Avatar.tsx so that file only exports the component (react-refresh/only-export-components
 *  needs that to keep Fast Refresh working). */
export const AVATAR_PRESETS = [
  'avatar-coral',
  'avatar-mint',
  'avatar-amber',
  'avatar-sky',
  'avatar-lavender',
  'avatar-rose',
  'avatar-sage',
  'avatar-ocean',
  'avatar-peach',
  'avatar-slate',
  'avatar-gold',
  'avatar-plum',
]
